import { usePartnerPickRecurringShiftConflictCheckLazyQuery } from 'domains/partner-pick-devices/api'

export const usePartnerPickRecurringShiftsConflictCheck = () => {
  const [fetchPartnerPickRecurringShiftConflicts, { loading, error, data }] =
    usePartnerPickRecurringShiftConflictCheckLazyQuery({
      fetchPolicy: 'network-only',
    })
  return {
    fetchPartnerPickRecurringShiftConflicts,
    conflictsData: data,
    conflictsLoading: loading,
    conflictsError: error,
  }
}
